var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.244.515c.282.284.441.67.441 1.07v1.136a.19.19 0 01-.188.189H.573a.187.187 0 01-.188-.19V1.587c0-.402.158-.787.44-1.07A1.5 1.5 0 011.89.071h14.292a1.5 1.5 0 011.063.443zM.825 11.737a1.518 1.518 0 01-.44-1.07V4.234a.19.19 0 01.188-.189h16.924a.188.188 0 01.188.19v6.432c0 .401-.159.786-.44 1.07a1.5 1.5 0 01-1.064.443H1.889a1.5 1.5 0 01-1.064-.443zm14.227-2.773h-2.256a.562.562 0 00-.564.567.57.57 0 00.564.568h2.256a.562.562 0 00.565-.568.57.57 0 00-.565-.567zM9.411 5.937H3.394a.562.562 0 00-.565.567.57.57 0 00.565.568H9.41a.562.562 0 00.564-.568.57.57 0 00-.564-.567zm-3.76 3.027H3.393a.562.562 0 00-.565.567.57.57 0 00.565.568H5.65a.562.562 0 00.564-.568.57.57 0 00-.564-.567z",
    fill: "#C8CAD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.f3c2f16070e3dfc1e1ede4e6071a70b5.svg";
export { ForwardRef as ReactComponent };